<template>
<div class="chapter">
<div class="inner_page">
<div id="ebook4252-2.html" xml:lang="en-US">
<div class="Basic-Text-Frame">
<p class="CN para-style-override-1" id="toc_marker-3"><span class="char-style-override-2">The Antiquarian</span></p>
<p class="BT-1st-para para-style-override-2"><span class="char-style-override-3">Gustavo Faverón Patriau</span></p>
<p class="BT-1st-para para-style-override-3"><span class="char-style-override-4">Translated from the Spanish</span></p>
<p class="BT-1st-para para-style-override-4"><span class="char-style-override-4">by Joseph Mulligan</span></p>
<p class="BT-1st-para para-style-override-5"><img alt="BlackCat.tif" class="image" src="images/BlackCat_fmt.png" width="8%"/></p>
<p class="BT-1st-para para-style-override-4"><span class="char-style-override-5">Black Cat</span></p>
<p class="BT-1st-para para-style-override-4"><span class="char-style-override-6">an imprint of Grove/Atlantic</span></p>
<p class="BT-1st-para para-style-override-4"><span class="char-style-override-5">New York</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ebook4252-2.vue?684dae8c